import Input from "../../../components/Input";
import { useTranslation } from "../../../i18n/TranslationProvider";

const AddAthleteInput = ({ index, register, errors }) => {
    const { t } = useTranslation();
    // modified for bulk uploads
    const fieldName = (name) => `athletes[${index}].${name}`;
    const formattedErrors = {};
    const fields = [
        "first_name",
        "last_name",
        "dob",
        "gender",
        "email",
        "phone",
        "school",
        "sport",
        "grad_year",
        "position",
        "previous_concussion_count",
    ];
    fields.forEach((field) => {
        const error = errors?.athletes?.[index]?.[field];
        if (error) {
            formattedErrors[fieldName(field)] = error;
        }
    });

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start mb-4">
            <Input
                label={t("onboarding.firstNameLabel")}
                name={fieldName("first_name")}
                register={register}
                errors={formattedErrors}
                required
            />

            <Input
                label={t("onboarding.lastNameLabel")}
                name={fieldName("last_name")}
                register={register}
                errors={formattedErrors}
                required
            />

            <Input
                label={t("onboarding.dobLabel")}
                type="date"
                name={fieldName("dob")}
                register={register}
                errors={formattedErrors}
                required
            />

            <Input
                label={t("onboarding.genderLabel")}
                type="select"
                name={fieldName("gender")}
                register={register}
                errors={formattedErrors}
                options={[
                    { value: "Male", label: t("onboarding.genderMale") },
                    { value: "Female", label: t("onboarding.genderFemale") },
                    { value: "Other", label: t("onboarding.other") },
                ]}
            />

            <Input
                label={t("auth.email")}
                type="email"
                name={fieldName("email")}
                register={register}
                errors={formattedErrors}
            />

            <Input
                label={t("athletes.phoneLabel")}
                type="tel"
                name={fieldName("phone")}
                register={register}
                errors={formattedErrors}
            />

            <Input
                label={t("athletes.schoolLabel")}
                name={fieldName("school")}
                register={register}
                errors={formattedErrors}
                required
            />

            <Input
                label={t("athletes.gradYearLabel")}
                type="number"
                name={fieldName("grad_year")}
                register={register}
                errors={formattedErrors}
            />

            <Input
                label={t("athletes.sportLabel")}
                name={fieldName("sport")}
                register={register}
                errors={formattedErrors}
            />

            <Input
                label={t("athletes.positionLabel")}
                name={fieldName("position")}
                register={register}
                errors={formattedErrors}
            />

            <Input
                label={t("athletes.previousConcussionsLabel")}
                type="number"
                name={fieldName("previous_concussion_count")}
                register={register}
                errors={formattedErrors}
            />
        </div>
    );
};

export default AddAthleteInput;